<template>
    <div :class="['recaptcha', { 'clear': isLoaded }]" v-bind="$attrs">
        <icon v-if="!isLoaded" type="solid" name="faSpinner" aria-hidden="true" spin></icon>
        <div ref="captcha" class="g-recaptcha" ></div>
    </div>
    <p class="td-error" v-for="error in errorCodes">
        {{ error }}
    </p>
</template>

<script>import script from './Captcha';
    export default script;</script>

<style lang="less">
    @import "./Captcha.less";
</style>